var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ipl-vip-layout-background",class:_vm.$vuetify.breakpoint.mdAndUp ? 'px-12' : 'px-2'},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }